import script from "./TounamentsView.vue?vue&type=script&setup=true&lang=js"
export * from "./TounamentsView.vue?vue&type=script&setup=true&lang=js"

import "./TounamentsView.vue?vue&type=style&index=0&id=663cb9ac&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-663cb9ac"]])

export default __exports__